export const getStrapiError = (err) => {
  // Обработка Network Error - когда нет response
  if (!err.response) {
    // Если это Network Error, возвращаем объект с информацией об ошибке
    if (err.code === 'ERR_NETWORK' || err.message === 'Network Error') {
      return {
        status: 0,
        statusText: 'Network Error',
        message: 'Не удалось подключиться к серверу',
        isNetworkError: true,
      };
    }
    // Для других ошибок без response возвращаем undefined (как было раньше)
    return;
  }
  
  const { data, status, statusText } = err.response;

  return {
    status,
    statusText,
    message: data,
  };
};
